import { useState, useEffect, useCallback } from 'react'
import { supabase } from '@/lib/supabase'
import type { Client } from '@planner/types'

export function useClient(id: string | undefined) {
  const [client, setClient] = useState<Client | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const [isFetching, setIsFetching] = useState(false)

  const fetchClient = useCallback(async () => {
    if (!id) {
      setLoading(false)
      return
    }

    setIsFetching(true)
    setError(null)

    try {
      const { data, error: fetchError } = await supabase
        .from('clients')
        .select('*, client_contacts(*)')
        .eq('id', id)
        .single()

      if (fetchError) {
        setError(fetchError as Error)
        setLoading(false)
      } else {
        setClient(data || null)
        setLoading(false)
      }
    } catch (err: any) {
      setError(err)
      setLoading(false)
    } finally {
      setIsFetching(false)
    }
  }, [id])

  useEffect(() => {
    fetchClient()
  }, [fetchClient])

  // loading = true tylko gdy faktycznie fetchujemy i nie mamy danych
  // Ale tylko jeśli id jest dostępne (query powinno się wykonać)
  const isLoading = !!id && isFetching && !client

  return { client, loading: isLoading, error, isFetching }
}
